
import { ParallaxEffect, ParallaxContext } from '../ParallaxEffect';
import { BaseParallaxEffect } from '../BaseParallaxEffect';

export class AuroraWavesEffect extends BaseParallaxEffect implements ParallaxEffect {
    public render(pc: ParallaxContext): void {
        const { ctx, layerIndex, config, width, time } = pc;
        const speed = time * 0.5 * config.parallaxSpeed;
        const points = Math.floor(20 * (config.parallaxComplexity || 1.0));
        const step = (width * 2) / points;
        
        const draw = () => {
            ctx.beginPath();
            ctx.strokeStyle = pc.color;
            ctx.lineWidth = (50 / layerIndex) * (config.parallaxScale || 1.0);
            ctx.lineCap = 'round';
            ctx.lineJoin = 'round';

            for (let i = -points/2; i <= points/2; i++) {
                const x = i * step;
                const y = Math.sin(x * 0.005 + speed + layerIndex) * 100 + (layerIndex - config.parallaxLayers/2) * 200;
                if (i === -points/2) ctx.moveTo(x, y);
                else ctx.lineTo(x, y);
            }
            ctx.stroke();
        };

        draw();
        this.applyGlow(pc, draw);
    }
}
